import { render } from "./InputSelectProfil.vue?vue&type=template&id=35d4412d"
import script from "./InputSelectProfil.vue?vue&type=script&lang=js"
export * from "./InputSelectProfil.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__